export const Scroll = {
    duration: 300,
    offset: 25
};
